<template>

  <div class="container" style="padding: 30px; margin-top: 50px">
    <div class="col-md-12 mb-3 mt-3" style="margin: 15px">
      <div class="card">
        <h1>จัดการกิจกรรมการเดินของผู้เข้าร่วมโครงการ</h1>
        <div class="days">
          <label v-for="d in days" :key="d.key">
            <input type="checkbox" :name="d.key" v-model="walk_management_list[d.key]">
            {{ d.label }}
          </label>
        </div>
        <div class="btn-container">
          <button class="btn-save" @click="save_walk_management">บันทึก</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import ActivitiesService from "../services/ActivitiesService";

export default {
  name: "Nav",
  components: {
  },
  props: {
    msg: String,
  },
  data() {
    return {
      list: [],
      code_list: [],
      number_code_create: '',
      days: [
        { key: 'sun', label: 'วันอาทิตย์' },
        { key: 'mon', label: 'วันจันทร์' },
        { key: 'tue', label: 'วันอังคาร' },
        { key: 'wed', label: 'วันพุธ' },
        { key: 'thu', label: 'วันพฤหัสบดี' },
        { key: 'fri', label: 'วันศุกร์' },
        { key: 'sat', label: 'วันเสาร์' },
      ],
      walk_management_list: ({
        sun: false,
        mon: false,
        tue: false,
        wed: false,
        thu: false,
        fri: false,
        sat: false
      })
    };
  },
  mounted() {
    this.getActivities()
  },
  methods: {
    getActivities() {
      ActivitiesService.getactivity(1).then((res) => {
        this.walk_management_list = res.data.days_of_week;
        // console.log(this.walk_management_list);
        if (typeof this.walk_management_list === 'string') {
          this.walk_management_list = JSON.parse(this.walk_management_list)
        }
      });
    },
    save_walk_management() {
      // console.log(this.walk_management_list);
      let activity = {
        days_of_week: JSON.stringify(this.walk_management_list),
        updated_by: this.currentUser.user_id
      }
      ActivitiesService.update_days_of_week(1, activity).then(() => {
        // console.log(res.data);
        alert('บันทึกข้อมูลสำเร็จ');
        this.getActivities()
      });
    },
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
};
</script>

<style scoped>
body {
  font-family: system-ui, sans-serif;
  margin: 24px;
  display: flex;
  justify-content: center;
}

.card {
  width: 100%;
  max-width: 520px;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 12px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
}

h1 {
  font-size: 20px;
  margin-bottom: 16px;
  text-align: center;
}

.days {
  display: grid;
  gap: 10px;
  margin-bottom: 20px;
}

label {
  display: flex;
  align-items: center;
  gap: 10px;
}

input[type="checkbox"] {
  width: 18px;
  height: 18px;
}

.btn-container {
  text-align: center;
}

.btn-save {
  background-color: #28a745;
  color: white;
  border: none;
  padding: 10px 24px;
  font-size: 16px;
  border-radius: 8px;
  cursor: pointer;
}

.btn-save:hover {
  background-color: #218838;
}
</style>
